import React from 'react';
import styled from '@emotion/styled';
import { Paper } from '../../../../../ui';
import { observer } from 'mobx-react';
import { MaybeCognitoError } from '@move-frontend/auth';
import {
	NewUserAccount,
	PersonalDetails,
	Submit,
	VehicleDetails,
} from './sections';
import { useAuthStore } from '../../../../auth/shared/store/useAuthStore';
import { TravelDetails } from './sections/TravelDetails';
import { EmailSuggestionStore } from '../../../domain/email-validation/stores/EmailSuggestionStore';
import Responsive from '../../../../../ui/utils/Responsive';

const StyledDetailsLayout = styled(Paper)`
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding-bottom: 24px;
	}
`;

interface IDetailsLayoutProps {
	signUpError?: MaybeCognitoError;
	saveDetailsError?: MaybeCognitoError;
	submitError?: Error;
	submitButtonText: string;
	hasHiddenConsentCheckbox?: boolean;
	hasHiddenRememberDetailsCheckbox?: boolean;
	emailSuggestionStore?: EmailSuggestionStore;
	modifyBooking?: boolean;
	bookingLicensePlate?: string;
}

export const DetailsLayout = observer(
	({
		signUpError,
		saveDetailsError,
		submitButtonText,
		submitError,
		hasHiddenConsentCheckbox,
		hasHiddenRememberDetailsCheckbox,
		emailSuggestionStore,
		modifyBooking,
		bookingLicensePlate,
	}: IDetailsLayoutProps) => {
		const authStore = useAuthStore();

		return (
			<StyledDetailsLayout>
				<PersonalDetails emailSuggestionStore={emailSuggestionStore} />
				<VehicleDetails
					modifyBooking={modifyBooking}
					bookingLicensePlate={bookingLicensePlate}
				/>
				<TravelDetails />
				{!authStore.isAuthenticated && <NewUserAccount />}
				<Submit
					signUpError={signUpError}
					saveDetailsError={saveDetailsError}
					submitError={submitError}
					canSaveDetails={authStore.isAuthenticated}
					submitButtonText={submitButtonText}
					hasHiddenConsentCheckbox={hasHiddenConsentCheckbox}
					hasHiddenRememberDetailsCheckbox={hasHiddenRememberDetailsCheckbox}
				/>
			</StyledDetailsLayout>
		);
	},
);
